module.exports = __webpack_public_path__ + "static/media/online.fec30bbd.png";